import React, { Component } from "react";
import { connect } from "react-redux";
import {} from "../../redux/app/actions";
import {} from "../../redux/csDsp/actions";
import {} from "../../redux/ui/actions";
import { addOutTimeTrAction, delOutTimeTrAction, updateOutTimeTrAction, changeOutTimeTrSelRowAction } from "../../redux/well/actions";
import { updateWellsTrAction, changeITSelRowAction } from "../../redux/boring/actions";
import Lgd, { probLgd } from "../common/Lgd";
import Sw from "../common/Sw";

const mapStateToProps = (state) => {
    return {
        outTimeTrData: state.wellReducer.outTimeTrData,
        outTimeTrSelRow: state.wellReducer.outTimeTrSelRow,
        checkPreInd: state.boringReducer.checkPreInd,
        wellsTrData: state.boringReducer.wellsTrData,
        iTSelRow: state.boringReducer.iTSelRow,
    };
};

class InputTemp extends Component {
    constructor(props) {
        super(props);
    }
    /*
     * 追加
     * @since ando 2023-8-10
     */
    addCat() {
        const updatedWellsTrData = this.props.wellsTrData.map((el, i) => {
            if (i === this.props.checkPreInd) {
                return { ...el, IT: [...el.IT, { TIME: 0, TEMP: 0 }] };
            }
            return el;
        });
        this.props.dispatch(updateWellsTrAction(updatedWellsTrData));
    }
    /*
     * 行削除
     * @since ando 2024-03-27
     */
    deleteSel() {
        const updatedWellsTrData = this.props.wellsTrData.map((el, i) => {
            if (i === this.props.checkPreInd) {
                return {
                    ...el,
                    IT: el.IT.filter((it, index) => index !== Number(this.props.iTSelRow)), // 修正: i → index
                };
            }
            return el;
        });

        // 新しい wellsTrData をセット
        this.props.dispatch(updateWellsTrAction(updatedWellsTrData));
    }

    /*
     * テーブルクリック
     * @since ando 2024-07-29
     */
    changeRow = (e) => {
        e.target.closest("tbody").childNodes.forEach((el) => {
            el.classList.remove("selRow");
        });
        const tr = e.target.closest("tr");
        tr.classList.add("selRow");
        this.props.dispatch(changeITSelRowAction(tr.id));
        console.log(`Row ${tr.id} clicked!`);
    };

    /*
     * テーブルデータ書き換え
     * @since ando 2024-07-29
     */
    changeField = (e, index, field) => {
        // 例えば、選択された種別を取得する処理などを追加
        const changeField = e.target.value;
        if (isNaN(changeField)) {
            alert("数値を入力してください。");
            return;
        }
        const updatedWellsTrData = this.props.wellsTrData.map((el, i) => {
            if (i === this.props.checkPreInd) {
                return {
                    ...el,
                    IT: el.IT.map((it, i) => (i === index ? { ...it, [field]: changeField } : it)),
                };
            }
            return el;
        });
        // 新しい wellsTrData をセット
        this.props.dispatch(updateWellsTrAction(updatedWellsTrData));
    };

    render() {
        return (
            <div>
                <Sw title="入熱温度" focusName="wells">
                    <div className="l-flex">
                        <button className="sBtn" onClick={() => this.addCat()}>
                            追加
                        </button>
                        <button className="sBtn" onClick={() => this.deleteSel()}>
                            削除
                        </button>
                    </div>
                    <div className="MeaInput l-mtSSS" style={{ overflowY: "scroll" }}>
                        <table className="idoTable">
                            <thead>
                                <tr>
                                    <th className="tsS">時間(d)</th>
                                    <th className="tsS">温度(℃)</th>
                                </tr>
                            </thead>
                            <tbody ref={(ref) => (this.tbRef = ref)}>
                                {this.props.wellsTrData[this.props.checkPreInd].IT.length !== 0 &&
                                    this.props.wellsTrData[this.props.checkPreInd].IT.map((el, index) => (
                                        <tr id={index} key={index} onClick={(e) => this.changeRow(e, 0)}>
                                            <td>
                                                <input className="textTR" type="text" value={el.TIME} onChange={(e) => this.changeField(e, index, "TIME")} />
                                            </td>
                                            <td>
                                                <input className="textTR" type="text" value={el.TEMP} onChange={(e) => this.changeField(e, index, "TEMP")} />
                                            </td>
                                        </tr>
                                    ))}
                            </tbody>
                        </table>
                    </div>
                </Sw>
            </div>
        );
    }
}

export default connect(mapStateToProps)(InputTemp);
